import React from 'react';

export default function BaseStations() {
  return <div>BaseStations</div>;
}
